import { createSlice } from "@reduxjs/toolkit"
import {
  deleteBooking,
  getAllBookings,
  getBookingDetails,
  updateBookingStatus,
} from "store/actions/bookingsAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  bookings: [],
  bookingDetails: {},
}

const usersSlice = createSlice({
  name: "bookings",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL List
    builder
      .addCase(getAllBookings.pending, state => {
        state.loading = true
      })
      .addCase(getAllBookings.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.bookings = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllBookings.rejected, (state, action) => {
        state.loading = false
      })

    // GET  DETAILS
    builder
      .addCase(getBookingDetails.pending, state => {
        state.loading = true
        state.bookingDetails = {}
      })
      .addCase(getBookingDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.bookingDetails = data
        }
      })
      .addCase(getBookingDetails.rejected, (state, action) => {
        state.loading = false
      })

    // DELETE
    builder
      .addCase(deleteBooking.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteBooking.fulfilled, (state, action) => {
        const { status } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.bookings = state.bookings.filter(item => item._id !== id)
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteBooking.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPDATE BOOKING STATUS
    builder
      .addCase(updateBookingStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateBookingStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.bookings = state.bookings.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateBookingStatus.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
